module.exports = __webpack_public_path__ + "img/oseisan.5909b507.jpg";